import { setClient, parserToken } from '../views/client/actions'

function checkTokenStatus (dispatch, token) {
  // attempt to grab the token from localstorage
  const storedToken = token || localStorage.getItem('token')

  // if it exists
  if (storedToken && storedToken != 'undefined') {
    // parse it down into an object
    const token = JSON.parse(storedToken)

    // this just all works to compare the total seconds of the created
    // time of the token vs the ttl (time to live) seconds
    const createdDate = new Date(token.created)
    const created = Math.round(createdDate.getTime() / 1000)
    const ttl = 1209600
    const expiry = created + ttl

    // if the token has expired return false
    if (created > expiry) return false

    // otherwise, dispatch the token to our setClient action
    // which will update our redux state with the token and return true
    dispatch(setClient(token))
    return true
  }

  return false
}

export function checkAuthorization (dispatch, token) {
  // attempt to grab the token from localstorage
  return checkTokenStatus(dispatch, token);
}

export function checkAccessAuthorization (props, callback = function(){}) {
  const {dispatch, history: { replace }, client} = props;

  if (client && client.token) return callback()

  if (checkTokenStatus(dispatch)) return callback()
  // nope?  okay back to login ya go.
  replace('/login')
  return callback()
}

// kiem tra xem user có quyền truy cập vào location này không
export function checkUrlAuthorization (location, dbContext, onError = function(){}) {
  const menus = dbContext.getRouteAllowed()
  if (menus.length === 0) {
    return
  }
  const {pathname} = location
  if (!pathname) {
    return
  }
  if (menus.findIndex(x => pathname.indexOf(x.Url) > -1) == -1) {
    return onError(pathname)
  }
}




// WEBPACK FOOTER //
// ./src/lib/check-auth.js